import React, { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { BankAccountReason } from '../../../app/models/BankAccountReason';
import useBankAccountReasonService from '../../../app/services/hooks/useBankAccountReasonService';
import BankAccountReasonForm from './forms/BankAccountReasonForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const BankAccountReasonCreate = ({ onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [bankAccountReason, setBankAccountReason] = useState<BankAccountReason>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingStoreBankAccountReason, storeBankAccountReason } = useBankAccountReasonService();

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando motivo de cuenta...');
        storeBankAccountReason(bankAccountReason, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({ title: 'Éxito', message: response.message });
                toast.success(response.message, { autoClose: 2500 });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
            },
            onFieldError: (res: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(res.data);
            }
        });
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <BankAccountReasonForm
                        bankAccountReasonDataForm={bankAccountReason}
                        setBankAccountReasonDataForm={setBankAccountReason}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={() => onCancel?.()} locked={fetchingStoreBankAccountReason} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreBankAccountReason} />
                </div>
            </div>
        </>
    );
};

export default BankAccountReasonCreate;
